export function parseColorFilename(filename) {
  const nameWithoutExtension = filename.replace(/\.[^/.]+$/, "");
  const lastDashIndex = nameWithoutExtension.lastIndexOf("-");
  const colorPart =
    lastDashIndex > 0
      ? nameWithoutExtension.substring(0, lastDashIndex)
      : nameWithoutExtension;
  const dimension =
    lastDashIndex > 0
      ? nameWithoutExtension.substring(lastDashIndex + 1)
      : null;
  const prefixMatch = colorPart.match(/^(nett_|alb_)(.+)$/);
  const remainingPart = prefixMatch ? prefixMatch[2] : colorPart;
  const idMatch = remainingPart.match(/^(\d{4})_(.+)$/);

  return {
    colorId: idMatch ? idMatch[1] : null,
    colorName: (idMatch ? idMatch[2] : remainingPart).replace(/_/g, " "),
    dimension
  };
}

export const sortColorsById = (colors) =>
  [...colors].sort((first, second) => {
    const firstId = Number(first?.colorId);
    const secondId = Number(second?.colorId);
    if (!Number.isNaN(firstId) && !Number.isNaN(secondId))
      return firstId - secondId;
    return String(first?.colorId ?? "").localeCompare(
      String(second?.colorId ?? ""),
      undefined,
      { numeric: true, sensitivity: "base" }
    );
  });

export const sortColors = (colors, sortConfig) => {
  if (!sortConfig.key) return colors;
  return [...colors].sort((first, second) => {
    let firstValue = first[sortConfig.key] ?? "";
    let secondValue = second[sortConfig.key] ?? "";
    if (["colorId", "price"].includes(sortConfig.key)) {
      firstValue = Number(firstValue) || 0;
      secondValue = Number(secondValue) || 0;
      return sortConfig.dir === "asc"
        ? firstValue - secondValue
        : secondValue - firstValue;
    }
    if (typeof firstValue === "boolean")
      return sortConfig.dir === "asc"
        ? firstValue
          ? -1
          : 1
        : firstValue
          ? 1
          : -1;
    return sortConfig.dir === "asc"
      ? String(firstValue).localeCompare(String(secondValue))
      : String(secondValue).localeCompare(String(firstValue));
  });
};

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export const cropBase64Center = (base64, cropWidth = 400, cropHeight = 400) =>
  new Promise((resolve) => {
    const image = new window.Image();
    image.src = base64;
    image.onload = () => {
      const width = Math.min(cropWidth, image.width);
      const height = Math.min(cropHeight, image.height);
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      canvas
        .getContext("2d")
        .drawImage(
          image,
          Math.floor((image.width - width) / 2),
          Math.floor((image.height - height) / 2),
          width,
          height,
          0,
          0,
          width,
          height
        );
      resolve(canvas.toDataURL("image/jpeg", 0.9));
    };
  });
